import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Avatar as MaterialAvatar,
  Typography,
  makeStyles,
} from '@material-ui/core'

import useAuth from 'hooks/useAuth'

import styles from './styles'

const useStyles = makeStyles(styles)

const Avatar = () => {
  const classes = useStyles()
  const auth = useAuth()
  const avatarLetters = auth.seller.tradeName
    .split(' ')
    .map(word => word[0])
    .join('')

  if (!auth.seller.logo) {
    return (
      <MaterialAvatar className={classes.avatar}>
        {avatarLetters[0]}
        {avatarLetters[avatarLetters.length - 1]}
      </MaterialAvatar>
    )
  }

  return (
    <MaterialAvatar src={auth.seller.logo} className={classes.avatar} />
  )
}

const Profile = ({ className, ...rest }) => {
  const classes = useStyles()
  const auth = useAuth()

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Avatar />
      <Typography variant="h4">{auth.seller.tradeName}</Typography>
      <Typography variant="body2">{auth.seller.email}</Typography>
    </div>
  )
}

Profile.propTypes = {
  className: PropTypes.string,
}

export default Profile
